import React, { useEffect, createElement } from 'react';
import { TopCountdownBar } from './components/TopCountdownBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { MidPageCTA } from './components/MidPageCTA';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { SocialProofPopup } from './components/SocialProofPopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Inject official Meta Pixel script directly (no npm dependency)
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    window.fbq('init', '848991698172368');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="w-full min-h-screen bg-dark-bg text-gray-900 overflow-x-hidden" data-id="element-0">
      <TopCountdownBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <MidPageCTA data-id="element-6" />
      <BeforeAfterSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <BonusesSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTASection data-id="element-12" />

      <SocialProofPopup data-id="element-13" />
    </main>;
}